import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody } from '@heroui/react';
import { useTranslation } from 'react-i18next';
import UserForm, { UserFormData } from './UserForm';

interface UserFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  userId?: string | null;
  defaultValues?: Partial<UserFormData> & { avatarFile?: { id: string; url: string } | null };
  isLoadingUser?: boolean;
}

const UserFormModal: React.FC<UserFormModalProps> = ({
  isOpen,
  onClose,
  userId,
  defaultValues,
  isLoadingUser = false,
}) => {
  const { t } = useTranslation('admin');

  const handleSuccess = () => {
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl" placement="center" backdrop="blur" scrollBehavior="inside">
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">
          {userId
            ? t('users.modal.edit.title', { defaultValue: 'Edit User' })
            : t('users.modal.create.title', { defaultValue: 'Create User' })}
        </ModalHeader>
        <ModalBody>
          <UserForm
            userId={userId}
            defaultValues={defaultValues}
            onCancel={onClose}
            onSuccess={handleSuccess}
            isLoadingUser={isLoadingUser}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default UserFormModal;
